/*
// 画像クロスフェード等（既存流用）
$(function(){
  $(".crossfade,.photos,.images").each(function(){
    var t=$(this),i=0,e=$("img:not(.hover)",t).length-1;
    $("img",t).each(function(){$img=$(this),$(this).data("src",$img.attr("src")),$img.attr("src",""),$img.addClass("loading")});
    var n=0,a=0;
    $("img",t).bind("load",function(){$(this).removeClass("loading"),$("img.none",t).hide().removeClass("none"),n=$(this).height(),a<n&&(a=n)});
    $("img",t).each(function(){$(this).attr("src",$(this).data("src"))});
    setInterval(function(){
      n=$("img",t).eq(i).height(),$(t).height(n),
      $("img:not(.hover)",t).eq(i).fadeOut("slow"),
      ++i>e&&(i=0),
      $("img:not(.hover)",t).eq(i).fadeIn("slow")
    },3e3);
    var o=!1;
    $(window).resize(function(){
      o && clearTimeout(o);
      o = setTimeout(function(){
        $(t).height($("img:first-child",t).height());
      }, 200);
    });
  });
});

// 横スクロールのカルーセル（既存流用）
$(function(){
  var t=$(".card").width(),i=0,e=$("#allCards .card").length;
  function n(){$("#allCards").stop().animate({left:-i*(t+200)+"px"},500,"easeOutExpo"),$("#page").text(i+1+"／"+e)}
  $("#allCards a.next").click(function(){i+1<e&&(i+=1),n()}),
  $("#allCards a.prev").click(function(){i-1>=0&&(i-=1),n()})});

// スライドショー（既存流用）
$(function(){
  $("#slideshow").each(function(){
    var t=$(this),i=0,e=$("img",t).length-1,n="#"+$(this).data("targetid");
    function a(){$("img",n).eq(i).stop().fadeOut(1e3),++i>e&&(i=0),$("img",n).eq(i).stop().fadeIn(1e3)}
    function o(){timer=setInterval(function(){a()},4e3)}
    $(n).height($("img",n).height()),$(n).html($(this).html()),
    $(n+" img").css({cursor:"pointer",position:"absolute",left:"0",top:"0"}).hide().removeClass("none"),
    $(n+" img:first-child").show(),o(),$(n).click(function(){clearInterval(timer),a(),o()})
  })
});
*/

// スムーススクロール（既存流用）
$(function(){
  var b=200;
  $('a[href^="#"]').on("click",function(){
    var f=$(this).attr("href");
    var e=$(f=="#"||f==""?"html":f);
    if (e.length){
      var a=e.offset().top-b;
      $("html, body").animate({scrollTop:a},550,"easeOutExpo");
      return false
    }
  })
});

//
// Splide 初期化
//
$(function () {
  const sliderOptions = {
    type: 'slide',
    gap: '10px',
    speed: 300,
    perPage: 4,
    pagination: false,
    arrows: true,
    drag: 'free',
    breakpoints: { 768: { perPage: 3 } },
  };
  $('.splide').not('.splide_home').each(function () {
    new Splide(this, sliderOptions).mount();
  });
});

